import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';

export type RequestUpdateButtonProps = {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
};

export const RequestUpdateButton: React.FC<RequestUpdateButtonProps> = ({
  onClick,
  label = 'Request Update',
  disabled = false,
}) => (
  <Box p={1}>
    <Button
      variant="contained"
      disableElevation
      startIcon={<EditIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  </Box>
);
